import axios from "axios";
import {getToken} from "../utils/cookies";

// create an axios instance
const service = axios.create({
    baseURL: process.env.REACT_APP_PROXY_URL,
    timeout: 10000, // request timeout
});
service.interceptors.request.use(
    (config) => {
        // do something before request is sent

        if (getToken()) {
            config.headers["Authorization"] = "Bearer " + getToken();
            config.headers["Content-Type"] = "application/json";
        }
        return config;
    },
    (error) => {
        // do something with request error
        console.log(error); // for debug
        return Promise.reject(error);
    }
);

export async function bindingTeams(uuid: string) {
    await service.post(`/teams/binding`, {
        state: uuid
    })
}

export async function getBindingStatus(): Promise<boolean> {
    const response = await service.get('/teams/check-binding-status');
    console.log('CheckBindingStatus', response)
    return response.data.isBound;
}
